module.exports = __webpack_public_path__ + "static/Cross-49a21f588eae9b268035ee7614f8a93a.png";